import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import API from "@/lib/api";
import { Badges } from "@/components/Badges";
import { ArrowLeft, Send, Phone, Mail, AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Conversation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [text, setText] = useState("");
  const endRef = useRef(null);

  const load = () => API.get(`/conversations/${id}`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [id]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [data]);

  const send = async () => {
    if (!text.trim()) return;
    await API.post(`/conversations/${id}/messages`, { text });
    setText("");
    load();
  };

  if (!data) return <Layout><p className="text-[#4A4E68]">Caricamento...</p></Layout>;
  const me = data.me;

  return (
    <Layout>
      <button onClick={() => navigate("/messages")} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Messaggi</button>

      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-4 mb-3">
        <button onClick={() => navigate(`/u/${data.other_profile?.user_id}`)} className="font-semibold text-[#0F1230]">{data.other_profile?.name}</button>
        <p className="text-xs text-[#4A4E68]">{data.request?.title}</p>
        <div className="mt-1"><Badges badges={data.other_profile?.badges || []} /></div>
        {data.contact && (
          <div className="mt-2 bg-[#E8F5E9] rounded-xl p-2 text-sm text-[#2A2E48] flex flex-wrap gap-3">
            {data.contact.phone && <span className="inline-flex items-center gap-1"><Phone size={13} /> {data.contact.phone}</span>}
            {data.contact.email && <span className="inline-flex items-center gap-1"><Mail size={13} /> {data.contact.email}</span>}
          </div>
        )}
      </div>

      <div className="space-y-2 mb-4" data-testid="messages-list">
        {data.messages.map((m) => {
          const mine = m.sender_id === me;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${mine ? "bg-[#1F4FE0] text-white" : "bg-white border border-[#DADFEA] text-[#2A2E48]"}`}>
                {m.text}
                {m.flagged && (
                  <div className={`text-[11px] mt-1 inline-flex items-center gap-1 ${mine ? "text-[#FFE3CF]" : "text-[#E8590C]"}`}><AlertTriangle size={11} /> Evita di scambiare contatti prima della condivisione</div>
                )}
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>

      <div className="fixed bottom-16 md:bottom-4 left-0 right-0 px-4">
        <div className="max-w-4xl mx-auto flex gap-2">
          <Input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Scrivi un messaggio..." className="bg-white" />
          <Button data-testid="message-send" onClick={send} className="bg-[#1F4FE0] text-white rounded-full shrink-0"><Send size={16} /></Button>
        </div>
      </div>
    </Layout>
  );
}
